export default __webpack_public_path__ + "static/media/crypto.f4a5ab8c.svg";